import { Download, FileText } from "lucide-react";
import { Badge } from "../../components/ui/badge";
import { useToast } from "../../components/ui/toast";
import { cn, formatINR } from "../../lib/utils";
import type { Invoice } from "./types";

export function InvoicesTab({ invoices }: { invoices: Invoice[] }) {
  const toast = useToast();

  return (
    <ul className="space-y-3">
      {invoices.map((inv) => (
        <li
          key={inv.id}
          className="flex items-center gap-4 rounded-xl shadow-card dark:shadow-card-dark bg-paper-card dark:bg-[#292524] p-4 transition-all hover:shadow-card-hover"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-soft text-ink-2">
            <FileText className="h-4 w-4" />
          </span>

          <div className="min-w-0 flex-1">
            <p className="font-mono text-sm font-bold text-ink">{inv.id}</p>
            <p className="text-xs text-ink-3">{inv.period}{inv.issuedAt !== "—" && ` · issued ${inv.issuedAt}`}</p>
          </div>

          <span className="font-mono text-sm font-bold text-ink">{formatINR(inv.amount)}</span>

          <Badge tone={inv.status === "paid" ? "success" : "warning"} pulse={inv.status === "pending"}>
            {inv.status === "paid" ? "Paid" : "Pending"}
          </Badge>

          <button
            disabled={inv.status !== "paid"}
            aria-label={`Download ${inv.id} PDF`}
            onClick={() => toast.info(`Downloading ${inv.id}.pdf…`)}
            className={cn(
              "rounded-lg p-2 transition-colors",
              inv.status === "paid"
                ? "text-brand hover:bg-brand-soft"
                : "cursor-not-allowed text-line",
            )}
          >
            <Download className="h-4 w-4" />
          </button>
        </li>
      ))}
    </ul>
  );
}
